import { camelToSnake } from 'utils';
import { Beneficiary, BeneficiaryEntityType } from './domain/beneficiary';
import { omit } from 'lodash';
import moment from 'moment';
import { Address, NetworkAddress } from 'policyholder/domain/policyholder';
import uuid from 'uuid';

export const beneficiaryToNetwork = (incomingBeneficiary: Beneficiary) => {
  let beneficiary: any = incomingBeneficiary;

  if (moment.isMoment(incomingBeneficiary.dateOfBirth)) {
    beneficiary = { ...incomingBeneficiary, dateOfBirth: incomingBeneficiary.dateOfBirth.format('YYYY-MM-DD') };
  }

  const networkAddress: NetworkAddress | undefined = beneficiaryAddressToNetwork(beneficiary.address);

  const networkBeneficiary = camelToSnake({
    ...omit(
      { ...beneficiary, type: beneficiary.entityType, address: networkAddress },
      ...[
        'beneficiaryId',
        ...(beneficiary.policyholderId ? ['id', 'firstName', 'lastName', 'email', 'dateOfBirth', 'address'] : []),
      ],
      ...(beneficiary.entityType === BeneficiaryEntityType.Company ? ['id'] : []),
    ),
    cellphone: beneficiary.cellphone?.number,
  });
  return networkBeneficiary;
};

/**
 * Converts a beneficiary address to network
 * Will return undefined if no address fields are populated (other than country)
 */
export const beneficiaryAddressToNetwork = (address: Address | undefined): NetworkAddress | undefined => {
  const { country, ...addressWithoutCountry } = address || {};

  return address && Object.values(addressWithoutCountry).some((value) => Boolean(value))
    ? {
        line_1: address.line1,
        line_2: address.line2,
        suburb: address.suburb,
        city: address.city,
        area_code: address.areaCode,
        country: address.country,
      }
    : undefined;
};

export const getBeneficiaryFromOrExisting = (
  prefillValues: Beneficiary[] | undefined,
  existingBeneficiaries: Beneficiary[] | undefined,
): Beneficiary[] => {
  if (prefillValues?.length && prefillValues.length > 0) {
    return prefillValues.map((b) => {
      b.beneficiaryId = uuid().toString();
      return b;
    });
  }

  return existingBeneficiaries || [];
};
